import "./CreateInitialAdminAccount.css";
import { useEffect, useState } from "react";
import Footer from "../../footer/Footer";
import ClearBanner from "../../sharedcomponents/clearBanner/ClearBanner";
import Logout from "../../sharedcomponents/Logout";
import { Button, FormControl, TextField } from "@mui/material";
import Passwordcheck from "../../sharedcomponents/Passwordcheck/Passwordcheck";
import axios from "axios";
import CustomSnackbar from "../../sharedcomponents/snackbar/CustomSnackbar";

function CreateInitialAdminAccount() {

    const [username, setUsername] = useState("");
    const [name, setName] = useState("");

    const [usernameBlank, setUsernameBlank] = useState(false);
    const [nameBlank, setNameBlank] = useState(false);

    const [correctUsername, setCorrectUsername] = useState(true);

    const [password, setPassword] = useState("");
    const [checkPasswordForm, setCheckPasswordForm] = useState(false);

    const [snackbarConfig, setSnackbarConfig] = useState({ open: false, message: "", variant: "" });

    useEffect(() => {
        const token = localStorage.getItem("jwtToken") || sessionStorage.getItem("jwtToken");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        if (sessionStorage.getItem("access_to_create_initial_admin_page") !== "Succesful") {
            Logout();
        }
    }, [])

    const[initialRender, setInitialrender] = useState(true);

    useEffect(() => {
        if(initialRender){
            setInitialrender(false)
        } else if (password !== "") {
            sendPostRequest();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [password]);

    function checkUsername() {
        let regex = /^[a-zA-Z0-9!#*+-._]+$/;
        if (regex.test(username) && username.length >= 3 && username.length < 31) {
            setCorrectUsername(true);
            return true;
        } else {
            setCorrectUsername(false);
            return false;
        }
    }

    const sendPostRequest = () => {
        if (checkUsername()) {
            axios.post('administrator/create', {
                "username": username,
                "name": name,
                "password": password
            }).then(() => {
                window.location.assign("/settings/home/");
            }).catch(() => {
                if(username === "") setUsernameBlank(true)
                if(name === "") setNameBlank(true)
                
                setSnackbarConfig({ open: true, message: "Benutzername schon vergeben.", variant: "error" });
                
                setPassword("");
                setCheckPasswordForm(false);
            })   
        } else {
            setPassword("");
            setCheckPasswordForm(false);
        }  
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        setCheckPasswordForm(true);
        if(username === "") setUsernameBlank(true)
        if(name === "") setNameBlank(true)
    }

    function createAdminForm() {
        return (
            <div className="initial-admin-creation-form-container">
                <form onSubmit={handleSubmit}>      
                    <FormControl sx={{width: '90%'}} className="initial-admin-creation-form-control">
                        <TextField                                 
                            autoFocus 
                            error={usernameBlank} 
                            required 
                            margin="normal" 
                            id="InitialAdministratorUsername" 
                            label="Benutzername" 
                            type="text"                             
                            variant="standard"
                            value={username}
                            onChange={e => {
                                setUsername(e.target.value);
                                setUsernameBlank(e.target.value === "");
                                setCorrectUsername(true);
                            }}
                            helperText={usernameBlank ? "Benutzername ist leer.": false}
                        />
                    </FormControl>
                    
                    <div className="create-admin-requirements" style={{ marginTop: '20px', width: '90%', textAlign: 'left' }}>
                        {!correctUsername && <p className="red" style={{ color: 'red' }}>Die Anforderungen sind nicht erfüllt.</p>}
                        <p>- 3-30 Zeichen</p>
                        <p>- Nur Buchstaben und Ziffern</p>
                        <p>- Folgende Sonderzeichen sind erlaubt: !#*+-._</p>
                        <p>- Keine Leerzeichen</p>
                    </div>

                    <FormControl 
                        sx={{
                            width: '90%',
                            '@media screen and (max-width: 1000px)': {
                                width: '100%'
                            }
                        }} >
                        <TextField 
                            error={nameBlank} 
                            required 
                            margin="normal" 
                            id="InitialAdministratorName" 
                            label="Name" 
                            type="text"                             
                            variant="standard" 
                            value={name}
                            onChange={e => {
                                setName(e.target.value);
                                setNameBlank(e.target.value === "");
                            }}
                            helperText={nameBlank ? "Name ist leer.": false}
                        />
                    </FormControl>
                    <Button type="submit" hidden/>
                </form>
                <Passwordcheck 
                    buttonText= "Administrator erstellen"
                    giveNewPassword={newPassword => setPassword(newPassword)} 
                    extraFormValidation={handleSubmit} 
                    activateFormValidation={checkPasswordForm} 
                    setActivateFormValidation={setCheckPasswordForm}
                />  
            </div>  
        )
    }

    return (
        <>
            <ClearBanner />
            <div className="create-initial-admin-account-header">
                <h3>Administrator Account erstellen</h3>
            </div>
            <hr className="divider-solid"/>
            <h5 className="create-initial-admin-account-info-text">Um nun die Zeiterfassung für Ihr Unternehmen zu nutzen, haben Sie hier die Möglichkeit einen Administrator Account zu erstellen. Dieser Account hat die Möglichkeit aktuelle Mitarbeiter- und Standorddaten anzusehen und zu bearbeiten. Zusätzlich kann dieser Account die Arbeitszeiten exportieren.</h5>
            <h5 className="create-initial-admin-account-info-text">Dieser Administrator (Sie oder ein von Ihnen ausgewählter Mitarbeiter) kann sich mit diesem Account in der TicTrack Adminoberfläche anmelden.</h5>
            {createAdminForm()}
            <Footer />
            <CustomSnackbar
                variant={snackbarConfig.variant} 
                message={snackbarConfig.message} 
                open={snackbarConfig.open} 
                onClose={() => setSnackbarConfig({ ...snackbarConfig, open: false })} 
            />
        </>
    )
}

export default CreateInitialAdminAccount;